// extracted by mini-css-extract-plugin
export default {"App":"Main_App__0zcgU","Content":"Main_Content__JtiyF"};